export const GET_APPROVAL_GROUP = "GET_APPROVAL_GROUP";
export const GET_APPROVAL_ROUTES = "GET_APPROVAL_ROUTES";

export const GET_PAYMENT_APPROVAL_ROUTE = "GET_PAYMENT_APPROVAL_ROUTE";
export const GET_APPROVAL_ROUTE_ENTITY = "GET_APPROVAL_ROUTE_ENTITY";
